import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GenericRepository } from "../generic-repository/GenericRepository";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { ChestStyle } from "../../models/ChestStyle/cheststyle.model";
import { IChestStyleRepository } from "./IChestStyleRepository";

@Injectable()
export class ChestStyleRepository extends GenericRepository<ChestStyle> implements IChestStyleRepository {
    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/ChestStyle', environment.urlAddress);
    }

    GetAll(currentPage: number, recordsPerPage: number): Observable<any> {
        return this._http
            .get(this.url + 'api/ChestStyle/SelectAll' + '/' + currentPage + '/' + recordsPerPage, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

    DeleteRec(ChestStyleCode: string) {
        return this._http.delete(this.url + 'api/ChestStyle/DeleteRec/' + ChestStyleCode, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

    SaveStyleNames(item: ChestStyle) {
        return this._http.post(this.url + 'api/ChestStyle/SaveStyleNames', item, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

}
